import { Box } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { GIFT_FLOW_SCHEDULE_ID } from '../../../../constants/giftFlow.constants';
import { getChiliPiperURL, getRecipientState } from '../../../../store/users/users.selectors';
import useGiftStatuses from '../../hooks/useGiftStatuses';
import RecipientActionWrapper from '../RecipientActionWrapper';

import useChiliPiperCalendar from './hooks/useChiliPiperCalendar';

const ChiliPiperCalendarPage: FC = () => {
  const { setActiveStatus } = useGiftStatuses();
  const recipient = useSelector(getRecipientState);
  const chiliPiperUrl = useSelector(getChiliPiperURL);

  useChiliPiperCalendar();

  useEffect(() => {
    setActiveStatus(GIFT_FLOW_SCHEDULE_ID);
  }, [setActiveStatus]);

  if (chiliPiperUrl === null) return null;

  const chilipiperUrl = `${new URL(chiliPiperUrl).toString()}?name=${recipient?.fullName}&email=${recipient?.email}`;
  return (
    <RecipientActionWrapper titleContent={null} childrenWrapperProps={{ flexDirection: 'column', height: '100%' }}>
      <Box component="iframe" src={chilipiperUrl} width="100%" height="100%" seamless />
    </RecipientActionWrapper>
  );
};

export default ChiliPiperCalendarPage;
